function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 100 100"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0l100 100m0-100L0 100M0 0h100v100H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.1 19.9v60.2h59.8V19.9z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.3 35.2v29.7h29.4V35.2z",
  fill: "none"
}));